import { useMutation, useQueries, useQuery, useQueryClient } from "react-query";
import axios from "axios";

import { convertToRichText } from "../getters/gettersV2";
import { useGenErrorMsgBanners } from "../useGenErrorMsgBanners";
import { UIContent } from "../../UIContent";
import { useAppSettingsContext } from "../../contexts/appSettingsContext";
import { useBannerContext } from "oolib";

const getTagsV3 = (type, options = {}) => { 
  let apiString, queryParams;

  if (options.tagCategory === "userTags") {
    apiString = "/api/users/getAllUsers";
    queryParams = {
      findQuery: JSON.stringify({
        profileType: type,
        ...(options.filters || {}),
      }),
      postDALFilter: JSON.stringify(options.postDALFilter || {}),
    };
  } else { //contentTags
    apiString = "/api/discovery/getData";
    queryParams = {
      configs: JSON.stringify({
        contentTypes: [type],
        findQuery: {
          ...(options.filters || {}),
          kp_published_status: 'published'
        },
        activeLang: options.activeLang,
      }),
    };
  }

  return axios.get(apiString, { params: queryParams }).then((res) => {
    return res.data.data
  });
};

export const useGetTagsV3 = (type, options = {}) => {
  const { APP_SETTINGS } = useAppSettingsContext();
  const activeLang = APP_SETTINGS.lang.value;
  const {genErrorMsgBanners} = useGenErrorMsgBanners()
  //multiple
  const query = useQuery(
    ["tagsV3", type, options, activeLang],
    () => getTagsV3(type, { ...options, activeLang }),
    {
      enabled: options.enabled,
      onError: (err) => {
        genErrorMsgBanners({err})			
			},
    }
  );
  return query;
};

export const useMultipleGetTagsV3 = (tagTypes = [], options = {}) => {
  //tagTypes can come in as string or object
  let tagTypesData = tagTypes.every((d) => typeof d === "string")
    ? tagTypes.map((d) => ({ tagType: d }))
    : tagTypes;
  const multipleQueries = tagTypesData.map((d) => {
    return {
      queryKey: d.tagType,
      queryFn: () => getTagsV3(d.tagType, { ...options, ...(d.options || {}) }),
      enabled: options.enabled,
    };
  });

  return useQueries(multipleQueries);
};


export const useCreateTagV3 = () => {
  const queryClient = useQueryClient();
  const { genErrorMsgBanners } = useGenErrorMsgBanners();
  return useMutation(
    ({ type, display, tagCategory, customFields = {} }) => {
      
        return axios.post(
          `/api/content/createAndPublishContent/${type}`,
          {
            main: { 
              ...(customFields.main || {}),
              title: display 
            },
            meta: { 
              ...(customFields.meta || {}),
              kp_content_type: type 
            },
            ...(customFields.tags 
              ? { tags: customFields.tags } 
              : {}
            )
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        ).then(res => ({ data: res.data.content }));
       
    },
    {
      onSuccess: (res, { type }) => {
        queryClient.invalidateQueries(["tagsV3", type]);
      },
      onError: (err) => {
        genErrorMsgBanners({ err });
      },
    }
  );
};
